import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { BRAND } from "../data/content";

const NAV = [
  { id: "home", label: "Beranda" },
  { id: "about", label: "Tentang" },
  { id: "services", label: "Layanan" },
  { id: "portfolio", label: "Karya" },
  { id: "packages", label: "Paket" },
  { id: "contact", label: "Kontak" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-700 ${
        scrolled || open
          ? "py-3 bg-[#0a0908]/85 backdrop-blur-xl border-b border-[#d4af37]/15"
          : "py-6 bg-transparent"
      }`}
    >
      <div className="max-w-[1480px] mx-auto px-6 sm:px-10 flex items-center justify-between">
        <button
          data-testid="header-logo"
          onClick={() => goTo("home")}
          className="flex items-center gap-3 group"
        >
          <img
            src={BRAND.logoUrl}
            alt="Sanggar Rias Adibah"
            className={`transition-all duration-700 ${
              scrolled ? "h-10" : "h-14"
            }`}
          />
          <span className="flex-col hidden leading-tight sm:flex">
            <span className="font-display text-[#fdfbf7] text-base tracking-[0.25em]">
              ADIBAH
            </span>
            <span className="text-[10px] tracking-[0.4em] uppercase text-[#d4af37]">
              Sanggar Rias
            </span>
          </span>
        </button>

        <nav className="items-center hidden lg:flex gap-9">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => goTo(n.id)}
              className="relative text-[11px] uppercase tracking-[0.3em] text-[#fdfbf7]/85 hover:text-[#d4af37] transition-colors group"
            >
              {n.label}
              <span className="absolute -bottom-1.5 left-1/2 -translate-x-1/2 w-0 h-px bg-[#d4af37] transition-all duration-500 group-hover:w-full" />
            </button>
          ))}
        </nav>

        <button
          data-testid="cta-header-book"
          onClick={() => goTo("contact")}
          className="hidden lg:inline-flex items-center gap-2 border border-[#d4af37]/60 text-[#d4af37] hover:bg-[#d4af37] hover:text-[#0a0908] px-6 py-3 text-[11px] tracking-[0.3em] uppercase transition-all duration-500"
        >
          Pesan Sesi
        </button>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="lg:hidden text-[#d4af37] p-2"
          aria-label="menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="lg:hidden absolute top-full inset-x-0 bg-[#0a0908]/95 backdrop-blur-xl border-t border-[#d4af37]/15"
        >
          <div className="flex flex-col gap-5 px-6 py-8">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`mobile-nav-${n.id}`}
                onClick={() => goTo(n.id)}
                className="text-left text-sm uppercase tracking-[0.25em] text-[#fdfbf7]/85 hover:text-[#d4af37] transition-colors"
              >
                {n.label}
              </button>
            ))}
            <button
              data-testid="cta-mobile-book"
              onClick={() => goTo("contact")}
              className="mt-4 inline-flex justify-center border border-[#d4af37]/60 text-[#d4af37] hover:bg-[#d4af37] hover:text-[#0a0908] px-6 py-3 text-xs tracking-[0.3em] uppercase transition-all"
            >
              Pesan Sesi
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
